var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "55.000000pt",
    height: "46.000000pt",
    viewBox: "0 0 55.000000 46.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,46.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 427 c-2 -7 -3 -98 -2 -202 l3 -190 158 -3 157 -3 0 159 0 158 -48 47 -48 47 -107 0 c-78 0 -109 -3 -113 -13z m178 -74 l3 -58 58 -3 57 -3 0 -115 0 -115 -132 3 -133 3 -3 173 -2 172 74 0 75 0 3 -57z m77 8 l35 -42 -45 3 -44 3 -3 44 c-4 53 8 52 57 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 220 c-43 -47 -39 -76 5 -34 l28 27 3 -57 c2 -31 8 -56 13 -56 6 0 11 25 13 56 l3 57 28 -27 c20 -19 31 -24 36 -16 8 13 -61 90 -81 90 -6 0 -28 -18 -48 -40z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.48aaaa79.svg";
export { ForwardRef as ReactComponent };